import { lazy } from "react";
export { MY_PROFILE_PATH } from "./my-profile-path";

export const MyProfile = lazy(() => import("./my-profile"));
